import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';

import messages from '../../MLSummary.messages'

function MLHOPCoverages({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-10">
                    {translator(messages.SpecialLimitations)}
                </h2>
                <p className="vertical-spacing-20">
                    {translator(messages.SpecialLimitationsPara)}
                </p>
                {data.map((term, index) => {
                    if (index % 2 === 0) {
                        return (
                            <div className="row clearfix">
                                {(data[index].isVisible_ML)?
                                    <>
                                        <div className="col-md-3 vertical-spacing-10"><strong>{data[index].name}</strong></div>
                                        <div className="col-md-3 vertical-spacing-10">{data[index].chosenTermValue}</div> 
                                    </>
                                    : <></>
                                }
                                {(data[index+1] && data[index+1].isVisible_ML)?
                                    <>
                                        <div className="col-md-3 vertical-spacing-10"><strong>{data[index+1].name}</strong></div>
                                        <div className="col-md-3 vertical-spacing-10">{data[index+1].chosenTermValue}</div>
                                    </>
                                    : <></>
                                }
                            </div>
        
                        );
                    }
                    return (<></>);
                })}
            </div>
        );
    }
    return ( <></> );
}

MLHOPCoverages.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLHOPCoverages.defaultProps = {
    data: [],
    show: false
};
export default MLHOPCoverages;
